import Header from "./Compartido/Header";
import TextosPagoResto from './PagoResto/TextosPagoResto.jsx';
import BrandsSection from "./Compartido/BrandsSection";
import Hero from "./Compartido/Hero";

import Footer from "./Compartido/Footer";

const Preautorizar = (props) => {
    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <Hero
                    eltexto={props.textosobrenosotros}
                    ruta={props.ruta}
                    laseccion="Pago"
                />
                <TextosPagoResto
                    datoscliente={props.datoscliente}
                    datospropiedad={props.datospropiedad}
                    reserva={props.reserva}
                    totalesreserva={props.totalesreserva}
                    restoapagar={props.restoapagar}
                    config={props.config}
                    tpvs={props.tpvs}
                    paycomet={props.paycomet}
                    tipopago={props.tipopago}
                    lang={props.lang}
                    ruta={props.ruta}
                    moneda={props.moneda}
                    transferencia={props.transferencia}
                    paypal={props.paypal}
                    stripe={props.stripe}
                />
            </main>
            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}
export default Preautorizar;
